import { render } from "./App.vue?vue&type=template&id=a93ce65c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a93ce65c&lang=css"
script.render = render

export default script